import JobMailList from "./jobMailList";
import JobStatus from "./jobStatus";
import JobType from "./jobType";
import OccurrenceType from "./occurrenceType";
import Project from "./project";
import User from "./user";

export default class Job {
  public idJob: number = 0;
  public idUser: number = 0;
  public idProject: number = 0;
  public jobGuid: string = "00000000-0000-0000-0000-000000000000";
  public jobName: string = "";
  public jobType: JobType = JobType.None;
  public jobStatus: string = JobStatus.Scheduled;
  public statusMessage: string = "";
  public isCancelled: boolean = false;
  public createDate: Date | undefined = undefined;
  public startDate: Date | undefined = undefined;
  public endDate: Date | undefined = undefined;
  public expiryDate: Date | undefined = undefined;
  public expiryDateUtc: Date | undefined = undefined;
  public project: Project | undefined = undefined;
  public user: User | undefined = undefined;
  public occurrenceType: OccurrenceType = OccurrenceType.Once;
  public occurrenceDay: string = "";
  public occurrenceTime: Date | undefined = undefined;
  public occurrenceDate: Date | undefined = undefined;
  public occurrenceLastJobStatus: string = "";
  public jobMailLists: JobMailList[] = [];
}
